// material-ui
import { styled, useTheme } from '@mui/material/styles';
import { Avatar, Box, Skeleton, Stack, Typography } from '@mui/material';

// project imports
import MainCard from 'ui-component/cards/MainCard';

// assets
import TableChartOutlinedIcon from '@mui/icons-material/TableChartOutlined';
import { useEffect, useState } from 'react';
import axios from 'axios';
import ApiLink from 'API';
import { useNavigate } from 'react-router';
import NumberFormat from 'react-number-format';

const CardWrapper = styled(MainCard)(({ theme }) => ({
    backgroundColor: theme.palette.primary.dark,
    color: theme.palette.primary.light,
    overflow: 'hidden',
    position: 'relative',
    transition: 'transform 0.25s ease, box-shadow 0.25s ease',
    '&:hover': {
        transform: 'translateY(-3px)',
        boxShadow: `0 14px 30px -10px ${theme.palette.primary.dark}`
    },
    '&:after': {
        content: '""',
        position: 'absolute',
        width: 260,
        height: 260,
        background: `linear-gradient(210.04deg, ${theme.palette.primary[200]} -50.94%, rgba(144, 202, 249, 0) 83.49%)`,
        borderRadius: '50%',
        top: -40,
        right: -200,
        opacity: 0.85,
        pointerEvents: 'none'
    },
    '&:before': {
        content: '""',
        position: 'absolute',
        width: 180,
        height: 180,
        background: `linear-gradient(140.9deg, ${theme.palette.primary[200]} -14.02%, rgba(144, 202, 249, 0) 77.58%)`,
        borderRadius: '50%',
        top: -130,
        right: -110,
        opacity: 0.7,
        pointerEvents: 'none'
    }
}));

const TotalIncome = () => {
    const theme = useTheme();
    const [isLoading, setisLoading] = useState(true);
    const navigate = useNavigate();
    const [Data, setData] = useState([]);

    useEffect(() => {
        let isMounted = true;
        const LoadData = async () => {
            try {
                setisLoading(true);
                const response = await axios.get(ApiLink + '/api/dashboard/sale/summary/income', {
                    withCredentials: true,
                    headers: { token: localStorage.getItem('token') }
                });
                if (isMounted) {
                    if (response.status === 200) {
                        setData(response.data.data || []);
                        setisLoading(false);
                    } else if (response.status === 401) {
                        localStorage.clear();
                        navigate(0);
                    }
                }
            } catch (error) {
                if (isMounted) {
                    setisLoading(false);
                    if (error?.response?.status === 401) {
                        localStorage.clear();
                        navigate(0);
                    }
                    console.log(error);
                }
            }
        };
        LoadData();
        return () => { isMounted = false; };
    }, []);

    return (
        <CardWrapper border={false} content={false}>
            <Box sx={{ p: 2.5, position: 'relative', zIndex: 1 }}>
                <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={2}>
                    <Stack spacing={0.5} sx={{ flex: 1, minWidth: 0 }}>
                        <Typography
                            variant="caption"
                            sx={{
                                color: 'rgba(255,255,255,0.7)',
                                textTransform: 'uppercase',
                                letterSpacing: '0.08em',
                                fontWeight: 700,
                                fontSize: '0.7rem'
                            }}
                        >
                            Total Income
                        </Typography>

                        {isLoading ? (
                            <Skeleton variant="text" width="70%" height={42} sx={{ bgcolor: 'rgba(255,255,255,0.15)' }} />
                        ) : (
                            <Typography
                                variant="h3"
                                sx={{
                                    color: '#fff',
                                    fontWeight: 800,
                                    fontSize: { xs: '1.4rem', sm: '1.6rem', md: '1.75rem' },
                                    letterSpacing: '-0.01em',
                                    overflowWrap: 'break-word'
                                }}
                            >
                                <NumberFormat
                                    thousandsGroupStyle="thousand"
                                    value={Data[0]?.summary || 0}
                                    prefix="₭"
                                    decimalSeparator="."
                                    displayType="text"
                                    thousandSeparator={true}
                                    allowNegative={true}
                                />
                            </Typography>
                        )}

                        <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.65)', mt: 0.5 }}>
                            ລາຍຮັບລວມຈາກການຂາຍ
                        </Typography>
                    </Stack>

                    <Avatar
                        variant="rounded"
                        sx={{
                            width: 52,
                            height: 52,
                            borderRadius: 2.5,
                            backgroundColor: theme.palette.primary[800],
                            color: '#fff',
                            boxShadow: '0 6px 16px -6px rgba(0,0,0,0.4)'
                        }}
                    >
                        <TableChartOutlinedIcon fontSize="medium" />
                    </Avatar>
                </Stack>
            </Box>
        </CardWrapper>
    );
};

export default TotalIncome;
